import { useEffect, useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { api, maskCep, maskDoc, maskPhone } from "@/lib/api";
import { ACCOUNT_TYPES, DOC_KINDS, DOC_LABELS, VEHICLE_LABEL } from "@/lib/boyCourier";
import { cn } from "@/lib/utils";

function DocThumb({ cid, kind, meta }) {
  const [url, setUrl] = useState("");
  const [fail, setFail] = useState(false);
  useEffect(() => {
    let u = "";
    api.get(`/boy/couriers/${cid}/files/${kind}`, { responseType: "blob" })
      .then((r) => { u = URL.createObjectURL(r.data); setUrl(u); })
      .catch(() => setFail(true));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [cid, kind]);
  const pdf = meta.content_type === "application/pdf";
  return (
    <a href={url || undefined} target="_blank" rel="noreferrer" className="group block overflow-hidden rounded-lg border bg-muted/30" data-testid={`boy-courier-doc-${kind}-${cid}`}>
      <div className="flex aspect-[4/3] items-center justify-center overflow-hidden">
        {!url ? (fail ? <span className="px-2 text-xs text-red-500">Não foi possível abrir</span> : <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />)
          : pdf ? <FileText className="h-8 w-8 text-muted-foreground" />
            : <img src={url} alt={DOC_LABELS[kind]} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />}
      </div>
      <p className="border-t px-2 py-1.5 text-xs font-medium">{DOC_LABELS[kind]}{pdf && " (PDF)"} · abrir</p>
    </a>
  );
}

const Item = ({ k, v, wide }) => (
  <div className={cn("min-w-0", wide && "col-span-2")}>
    <dt className="text-xs text-muted-foreground">{k}</dt>
    <dd className="break-words font-medium">{v || "—"}</dd>
  </div>
);

export function CourierDetails({ c }) {
  const b = c.bank;
  const kinds = DOC_KINDS.filter((k) => c.docs?.[k]);
  return (
    <div className="grid gap-4 border-t pt-4 lg:grid-cols-2" data-testid={`boy-courier-details-${c.id}`}>
      <dl className="grid grid-cols-2 content-start gap-x-4 gap-y-2.5 text-sm">
        <Item k="CPF" v={maskDoc(c.cpf)} />
        <Item k="Celular / WhatsApp" v={maskPhone(c.whatsapp || c.phone)} />
        <Item k="E-mail" v={c.email} wide />
        <Item k="Veículo" v={VEHICLE_LABEL[c.vehicle] || (c.plate && `Placa ${c.plate}`)} />
        <Item k="Região" v={`${c.city}/${c.state}${c.cep ? ` · CEP ${maskCep(c.cep)}` : ""}`} />
        {b && <Item k="Banco" v={`${b.code} · ${b.name}`} wide />}
        {b && <Item k="Tipo de conta" v={ACCOUNT_TYPES[b.type]} />}
        {b && <Item k="Agência / Conta" v={`${b.agency} / ${b.account}`} />}
        {b && <Item k="Titular da conta" v={`${b.holder} · CPF ${maskDoc(b.holder_cpf)}`} wide />}
      </dl>
      {kinds.length ? (
        <div className="grid grid-cols-2 content-start gap-3 sm:grid-cols-3">
          {kinds.map((k) => <DocThumb key={k} cid={c.id} kind={k} meta={c.docs[k]} />)}
        </div>
      ) : <p className="text-xs text-muted-foreground">Cadastro feito antes do envio de documentos.</p>}
    </div>
  );
}
